export type ThreadedComment = {
  id: number;
  parent_id: number | null;
  created_at: string;
};

export function groupComments<T extends ThreadedComment>(comments: T[]) {
  const repliesByParent = new Map<number, T[]>();
  const topLevel: T[] = [];

  for (const comment of comments) {
    if (comment.parent_id) {
      const replies = repliesByParent.get(comment.parent_id) ?? [];
      replies.push(comment);
      repliesByParent.set(comment.parent_id, replies);
    } else {
      topLevel.push(comment);
    }
  }

  for (const replies of repliesByParent.values()) {
    replies.sort(
      (left, right) => new Date(left.created_at).getTime() - new Date(right.created_at).getTime(),
    );
  }

  return { topLevel, repliesByParent };
}
